import type { EntityGraphNode } from "../../../../core/engine/EntityGraphNode/EntityGraphNode.type"
import type { JungleEntity } from "../../../../core/entity/EntityType/Jungle"
import getManhattanDistance from "../../../../core/tile_position_xy/getManhattanDistance"

type JungleCluster = Array<EntityGraphNode<JungleEntity>>
type JungleClusterList = Array<JungleCluster>

// Step 1: Create initial clusters based on adjacency
export default function createInitialJungleClusters(
  entities: JungleCluster
): JungleClusterList {
  const visited = new Set<number>()
  const chunks: JungleClusterList = []

  function floodFill(start: EntityGraphNode<JungleEntity>, cluster: JungleCluster) {
    const stack = [start]
    visited.add(start.id)

    while (stack.length > 0) {
      const currentEntNode = stack.pop()!
      const currentEnt = currentEntNode.raw()
      cluster.push(currentEntNode)

      for (const otherEntNode of entities) {
        if (!visited.has(otherEntNode.id) && getManhattanDistance(currentEnt, otherEntNode.raw()) === 1) {
          visited.add(otherEntNode.id)
          stack.push(otherEntNode)
        }
      }
    }
  }

  for (const entityNode of entities) {
    if (!visited.has(entityNode.id)) {
      const cluster: JungleCluster = []
      floodFill(entityNode, cluster)
      chunks.push(cluster)
    }
  }
  return chunks
}